import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PerformWorkerTimesheetActionMutationCgResponse,
  PerformWorkerTimesheetActionMutationVariables,
  WorksTimekeepingManagerUpsertHoursMutationCgResponse,
  WorksTimekeepingManagerUpsertHoursMutationVariables,
} from '@common/graphql/schema';
import { HourBlockErrors, ReviewWorkerTimesheet } from '@timekeeping/graphql';

export const PerformWorkerTimesheetAction: TypedDocumentNode<
  PerformWorkerTimesheetActionMutationCgResponse,
  PerformWorkerTimesheetActionMutationVariables
> = gql`
  mutation PerformWorkerTimesheetAction(
    $workerTimesheetId: ID!
    $action: WorkerTimesheetActions!
  ) {
    result: worksTimekeepingPerformWorkerTimesheetAction(
      workerTimesheetId: $workerTimesheetId
      action: $action
    ) {
      workerTimesheet {
        ...ReviewWorkerTimesheet
      }
    }
  }
  ${ReviewWorkerTimesheet}
`;

export const ManagerUpsertHours: TypedDocumentNode<
  WorksTimekeepingManagerUpsertHoursMutationCgResponse,
  WorksTimekeepingManagerUpsertHoursMutationVariables
> = gql`
  mutation WorksTimekeepingManagerUpsertHours(
    $input: WorksTimekeepingAddHoursInput!
  ) {
    result: worksTimekeepingManagerUpsertHours(input: $input) {
      workerTimesheet {
        ...ReviewWorkerTimesheet
      }
      errors {
        ...HourBlockErrors
      }
    }
  }
  ${ReviewWorkerTimesheet}
  ${HourBlockErrors}
`;
